import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactComponent } from './contact/contact.component';
import { authGuardFn } from '@auth0/auth0-angular';
import { InvestorDashboardComponent } from './investor-dashboard/investor-dashboard.component';
import { SeriesDashboardComponent } from './series-dashboard/series-dashboard.component';
import { AssetDashboardComponent } from './asset-dashboard/asset-dashboard.component';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { AuthErrorComponent } from './auth-error/auth-error.component';
import { DocumentReviewComponent } from './document-review/document-review.component';
import { AdminAuthGuard } from './guards/admin-auth.guard';
import { InternalUserAuthGuard } from './guards/internal-user-auth.guard';
import { GcmNotfoundComponent } from '@gcm/gcm-ui-angular';
import { CustomGcmAppComponent } from './shared/custom-gcm-app/custom-gcm-app.component';
import { PortfolioDashboardComponent } from './portfolio-dashboard/portfolio-dashboard.component';
import { DealDashboardComponent } from './deal-dashboard/deal-dashboard.component';

export const GCMRoutes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'investor' },
    { path: 'login', redirectTo: 'investor' }, // Redirect to investor which triggers Auth0 login
    // Show header and sidenav only when user is logged in with Auth0.
    {
        path: '',
        component: CustomGcmAppComponent,
        canActivate: [authGuardFn],
        children: [
            { path: 'investor', component: InvestorDashboardComponent },
            { path: 'investor/:investorId', component: InvestorDashboardComponent },
            { path: 'investor/:investorId/portfolio/:portfolioId', component: PortfolioDashboardComponent, canActivate: [InternalUserAuthGuard] },
            { path: 'investor/:investorId/series/:seriesId', component: SeriesDashboardComponent },
            { path: 'investor/:investorId/series/:seriesId/deal/:dealId', component: DealDashboardComponent },
            { path: 'investor/:investorId/series/:seriesId/deal/:dealId/asset/:assetId', component: AssetDashboardComponent },
            { path: 'contact', component: ContactComponent, canDeactivate: [CanDeactivateGuard] },
            { path: 'document-review', component: DocumentReviewComponent, canActivate: [AdminAuthGuard] },
        ]
    },

    { path: 'app/main', pathMatch: 'prefix', redirectTo: 'login' },
    { path: '404', component: GcmNotfoundComponent },
    { path: 'auth-error', component: AuthErrorComponent },
    { path: '**', redirectTo: '/404' },
];

@NgModule({
    imports: [RouterModule.forRoot(GCMRoutes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
